var _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "url(#paint0_linear_302_500)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6394 20.0367C17.1148 20.0367 16.6794 19.6313 16.642 19.108L16.1391 12.0713C16.0977 11.4924 16.5562 11 17.1365 11H18.8635C19.4438 11 19.9023 11.4924 19.8609 12.0713L19.358 19.108C19.3206 19.6313 18.8852 20.0367 18.3606 20.0367H17.6394ZM18 25C17.4167 25 16.9375 24.822 16.5625 24.4661C16.1875 24.1102 16 23.6883 16 23.2006C16 22.6996 16.1875 22.2844 16.5625 21.9548C16.9375 21.6121 17.4167 21.4407 18 21.4407C18.5972 21.4407 19.0764 21.6121 19.4375 21.9548C19.8125 22.2844 20 22.6996 20 23.2006C20 23.6883 19.8125 24.1102 19.4375 24.4661C19.0764 24.822 18.5972 25 18 25Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_302_500",
    x1: -2.23691e-8,
    y1: 17.027,
    x2: 36.0036,
    y2: 17.1208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3CB03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD600"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.4308d3192744a38e4fb55fe281ea67cd.svg";
export { ForwardRef as ReactComponent };